import { FrontendStatusType } from 'store/models/dashboard';

export const CAMPAIGN_MAX_ITEMS_IN_RESPONSE = 20;

export enum CampaignArchiveReason {
    ArchivedVacancy = 'ARCHIVED_VACANCY',
    OldPrices = 'OLD_PRICES',
    Transfer = 'TRANSFER',
    ObsoleteCampaign = 'OBSOLETE_CAMPAIGN',
    OldSource = 'OLD_SOURCE',
    ExpiredAccount = 'EXPIRED_ACCOUNT',
    OldBlockedCampaign = 'OLD_BLOCKED_CAMPAIGN',
    WrongAccount = 'WRONG_ACCOUNT',
}

export enum CampaignStatus {
    Active = 'ACTIVE',
    Blocked = 'BLOCKED',
    Archived = 'ARCHIVED',
    ActiveWithDelayedStart = 'ACTIVE_WITH_DELAYED_START',
    InactiveDueToEndDate = 'INACTIVE_DUE_TO_END_DATE',
}

export enum CampaignPauseReason {
    BudgetExceeded = 'BUDGET_EXCEEDED',
    DailyBudgetExceedStatus = 'DAILY_BUDGET_EXCEEDED',
}

export const activeStatuses: FrontendStatusType[] = [
    CampaignStatus.Active,
    CampaignStatus.ActiveWithDelayedStart,
    CampaignPauseReason.BudgetExceeded,
    CampaignPauseReason.DailyBudgetExceedStatus,
    CampaignStatus.InactiveDueToEndDate,
];

export const warnStatuses: FrontendStatusType[] = [
    CampaignPauseReason.BudgetExceeded,
    CampaignPauseReason.DailyBudgetExceedStatus,
    CampaignStatus.InactiveDueToEndDate,
];

export const MAX_CAMPAIGN_SELECT = 100;
